module.exports = __webpack_public_path__ + "static/media/Experten01.eca864b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Experten01.jpg
// module id = 356
// module chunks = 0